import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wintersportreisen',
  templateUrl: './wintersportreisen.component.html',
  styles: []
})
export class WintersportreisenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
